import * as FS from '@fullstory/browser';
import environment from '../../environment';
import * as envTypes from '../../constants/envTypes';

let isInitialized = false;

function ensureInitialized() {
  if (!isInitialized) {
    console.warn('FullStory not initialized yet. Call initializeRecordingService() first.');
  }

  return isInitialized;
}

export function initializeRecordingService() {
  if (ensureInitialized()) {
    console.warn('FullStory already initialized');

    return;
  }

  FS.init({
    orgId: environment.fullStory.orgId,
    devMode: environment.app.currentEnv !== envTypes.PROD,
  });

  isInitialized = true;
  console.log('FullStory initialized successfully');
}

export function event(...args) {
  if (!ensureInitialized()) {
    console.debug('FullStory event skipped (not initialized):', ...args);

    return;
  }

  FS.event(...args);
}

export function identify(...args) {
  if (!ensureInitialized()) {
    console.debug('FullStory identify skipped (not initialized):', ...args);

    return;
  }

  FS.identify(...args);
}

export * from '@fullstory/browser';
